export const appConfig = {
    basePath: (process.env.PUBLIC_URL || '').replace(/\/$/, ''),
};

/**
 * Return a path prefixed by a base path correctly
 * @param path
 */
export function withBasePath(path: string): string {
    return appConfig.basePath + '/' + path.replace(/^\/+/, '');
}

export default appConfig;
